import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Popover, Progress, Divider, message, Button } from 'antd';
import Iconfont from '@utils/Iconfont';
import { useLocation, useNavigate } from "react-router-dom";
import API from '@api/api.js';
import { AppContext, channel } from '@utils/AppContext';
import styles from './loggedHead.module.scss'
import CountUp from 'react-countup';
import eventBus from '@utils/eventBus';
import CouponModal from '@view/compoents/couponModal/couponModal'
import SwitchHomePageType from '../SwitchHomePageType';
import Utils from '@utils/utils'
import * as PromoteButtons from '../PromoteButtons';
import { PlusOutlined } from '@ant-design/icons';
import { SELECT_ORG_TYPE } from '@utils/CONST'



function LoggedAvatar(props) {
    const { goBack } = props
    const navigate = useNavigate();
    const { globalUser, globalOrgInfo } = useContext(AppContext);
    const [open, setOpen] = useState(false)
    const [changeContentOpen, setChangeContentOpen] = useState(false)

    const LevelName = ['FREE', 'PSAI', 'PSAI PRO', 'PSAI MAX', 'PSAI ULTRA', 'PSAI', 'PSAI PLUS', 'PSAI PRO', 'PSAI MAX', 'PSAI ULTRA']
    const LevelZHName = ['免费账户', '捕光逐影', '妙影生花', '非凡大师', '商海畅行', '入门版', '基础版', '高级版', '旗舰版', '至尊版']

    const handleOpenChange = (newOpen) => {
        if (!newOpen) {
            setChangeContentOpen(false)
        }
        setTimeout(() => {
            setOpen(newOpen)
        }, 30)

        if (newOpen) {
            eventBus.emit('updateUserInfo')
            eventBus.emit('getUserOrgInfo')
            eventBus.emit('updatePower')
            eventBus.emit('updateActivityInfo')
        }
    }

    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100) ?
            globalUser?.membership?.level : 0
    }, [globalUser])


    const postChangeOrg = (id) => {
        API.postChangeOrg({
            orgId: id
        }).then((res) => {
            if (res.code == 0) window.location.reload()
        })
    }


    const changeContent = (
        <div className={styles.changeAccountWrap}>
            <div className={`${styles.changeAccountWrapTop} _beauty_scrollbar`}>
                {
                    globalOrgInfo?.orgList?.slice(0, 1).map((item, index) => (
                        <div
                            onClick={() => postChangeOrg(item.id)}
                            className={`${styles.changeAccountItem} ${item.current ? styles.changeAccountItemActive : ''}`}
                            key={index}>
                            {
                                item.orgName == '个人版' ? <img className={styles.img1} src={require('@assets/images/icon_Avatar_2.png')} alt="" /> :
                                    <span className={styles.orgName}>{item.orgName?.slice(0, 1)}</span>
                            }
                            {
                                item.orgName == '个人版' ? <span>{globalUser?.mobile ? globalUser?.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : globalUser?.email}</span> :
                                    <span>{item.orgName}</span>
                            }
                        </div>
                    ))
                }
                <Divider plain style={{ color: '#B9C3D0', fontSize: '12px', margin: '5px 0' }}>企业账号</Divider>
                {
                    globalOrgInfo?.orgList?.slice(1, 10).map((item, index) => (
                        <div
                            onClick={() => postChangeOrg(item.id)}
                            className={`${styles.changeAccountItem} ${item.current ? styles.changeAccountItemActive : ''}`}
                            key={index}>
                            {
                                item.orgName == '个人版' ? <img className={styles.img1} src={require('@assets/images/icon_Avatar_2.png')} alt="" /> :
                                    <span className={styles.orgName}>{item.orgName?.slice(0, 1)}</span>
                            }
                            {
                                item.orgName == '个人版' ? <span>{globalUser?.mobile ? globalUser?.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : globalUser?.email}</span> :
                                    <span>{item.orgName}</span>
                            }
                        </div>
                    ))
                }
                {
                    globalOrgInfo?.orgList?.length > 10 ? <div
                        className={styles.checkAllItem}
                        onClick={() => {
                            setChangeContentOpen(false)
                            eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG })
                            setTimeout(() => {
                                setOpen(false)
                            }, 30)
                        }}
                    >
                        查看全部
                    </div> : null
                }

            </div>
            <Button
                className={styles.createTeamBtn}
                onClick={() => {
                    setChangeContentOpen(false)
                    eventBus.emit('OPEN_CREATE_TEAM')
                    setTimeout(() => {
                        setOpen(false)
                    }, 30)
                }}
                type="primary">
                <PlusOutlined />新建企业
            </Button>
        </div>
    )
    const avatarContent = (
        <div className={styles.LoggedAvatarPopover_box}>
            {
                !!globalUser &&
                <div>
                    <div className={styles.popover_box_}>
                        <div className={styles.popover_box_top}>
                            {
                                globalOrgInfo?.isPersonal ? <img className={styles.img1} src={require('@assets/images/icon_Avatar_2.png')} alt="" /> :
                                    <span className={styles.teamImg}>{globalOrgInfo?.current?.orgName.slice(0, 1)}</span>
                            }
                            <ul>
                                {
                                    (globalUser?.thirdPartyLoginChannel?.includes('wechat') && !globalUser?.mobile) ? '微信登录' :
                                        globalOrgInfo?.isPersonal ? <li className={styles.li1}>{globalUser?.mobile ? globalUser?.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : globalUser?.email}</li> :
                                            <li>{globalOrgInfo?.current?.orgName}</li>
                                }
                            </ul>
                            <Popover
                                placement="bottomLeft"
                                content={changeContent}
                                trigger="click"
                                open={changeContentOpen}
                                onOpenChange={(newOpen) => setChangeContentOpen(newOpen)}
                            >
                                <span
                                    className={styles.changeAccount}>
                                    切换账号 <Iconfont type="icon-changeOutlined" className={styles.Icon} />
                                </span>
                            </Popover>
                        </div>
                        <div className={`${styles.popover_box_middle} 
                        ${styles["popover_box_middleLeave_" + memberLevel]} 
                        ${!globalOrgInfo?.isPersonal ? styles["popover_box_middleLeave_person_" + (memberLevel - 4)] : ''}`}>
                            <p className={styles.member_p}>
                                <span></span>
                                <span>{(!globalOrgInfo?.isPersonal && memberLevel === 0) ? 'PSAI' : LevelName[memberLevel]}</span>
                                {
                                    !globalOrgInfo?.isPersonal ? <span className={styles.teamSpan}>TEAM</span> : memberLevel === 4 ? null :
                                        <span onClick={() => { setOpen(false); props.openPayClick() }}>
                                            {memberLevel === 0 ? '开通会员' : '升级'}
                                        </span>
                                }
                                {
                                    !globalOrgInfo?.isPersonal && memberLevel === 0 &&
                                    <span onClick={() => { setOpen(false); props.openPayClick() }}>激活企业</span>
                                }
                            </p>
                            <p className={styles.member_p2}>{globalOrgInfo?.isPersonal ? LevelZHName[memberLevel] :
                                memberLevel === 0 ? '未激活' : LevelZHName[memberLevel]}</p>
                            {
                                globalUser?.membership?.expiredTime &&
                                <p className={styles.member_p3}>有效期至：{globalUser?.membership?.expiredTime}</p>
                            }
                        </div>
                        <Button
                            onClick={() => {
                                setOpen(false)
                                eventBus.emit('OPEN_CREATE_TEAM')
                            }}
                            type='primary'
                            className={styles.createTeamBtn}>
                            <Iconfont type="icon-reuseOutlined" className={styles.Icon} /> 创建企业
                        </Button>
                        {
                            globalOrgInfo?.current?.role == 'member' ? null : globalOrgInfo?.isPersonal ?
                                <p className={styles.center_p}
                                    onClick={() => {
                                        window.open("/home/personalCenter/personalTransaction", "_blank");
                                        setOpen(false);
                                    }}
                                >个人中心
                                </p> : <p className={styles.center_p}
                                    onClick={() => {
                                        window.open("/home/personalCenter/memberManage", "_blank");
                                        setOpen(false);
                                    }}
                                >企业管理</p>
                        }
                        {
                            globalUser?.wholesales === 1 && <p className={styles.center_p} onClick={() => {
                                window.open("/home/personalCenter/redemptioncodeList");
                                setOpen(false);
                            }}>分销管理</p>
                        }
                        <p className={styles.center_p} style={{ marginBottom: 0 }}
                            onClick={() => {
                                window.open("/home/product/redemptioncodePage");
                                setOpen(false);
                            }}>会员兑换</p>
                    </div>
                    <p className={styles.logout_p} onClick={() => { goBack(); setOpen(false); }}>退出登录</p>
                </div>
            }
        </div>
    );

    return (
        <Popover
            classNames={{ root: styles.LoggedAvatarPopover }}
            placement="bottomRight"
            content={avatarContent}
            trigger="hover"
            onOpenChange={handleOpenChange}
            open={open}
        >
            <div className={`${styles.LoggedAvatar} ${globalOrgInfo?.isPersonal ?
                styles["LoggedAvatarLevel_" + memberLevel] : styles.LoggedAvatarLevel_Team}`}>
                {
                    globalOrgInfo?.isPersonal ? <img
                        className={styles.LoggedAvatarImage}
                        onClick={() => setOpen(true)}
                        src={require('@assets/images/icon_Avatar_2.png')} alt="" /> :
                        <span className={styles.teamImg}>{globalOrgInfo?.current?.orgName.slice(0, 1)}</span>
                }

                <span className={styles.orgName}>{globalOrgInfo?.isPersonal ? '个人版' : globalOrgInfo?.current?.orgName}</span>
            </div>
        </Popover>
    )
}

function LoggedHead(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const payChildRef = useRef(null);
    const couponChildRef = useRef()
    const { globalBalance, setHasToken, setGlobalUser, globalUser, globalOrgInfo, setGlobalOrgInfo } = useContext(AppContext);
    const [powerBalance, setPowerBalance] = useState(globalBalance)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setPowerBalance(globalBalance)
    }, [globalBalance])

    // 用来检查是否有虹豆/套餐到期需要提醒
    useEffect(() => {
        eventBus.emit('updateOrderList')
    }, [])

    // 多账号登录时更新账号信息
    useEffect(() => {
        eventBus.emit('updateUserInfo')
        eventBus.emit('getUserOrgInfo')
        eventBus.emit('updatePower')
        eventBus.emit('updateActivityInfo')
    }, [location])

    const goBack = () => {
        API.logout({}).then(res => {
            setGlobalUser()
            setGlobalOrgInfo()
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            localStorage.removeItem('channel')
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
            setHasToken(false)
            navigate('/')
        }).catch((error) => {
            setGlobalUser()
            setGlobalOrgInfo()
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            localStorage.removeItem('channel')
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
            setHasToken(false)
            navigate('/')

        })
    }

    const openCouponClick = () => {
        couponChildRef.current.openClick()
    }

    const [startBalance, setStartBalance] = useState(0)
    const [endBalance, setEndBalance] = useState(0)
    const endBalanceRef = useRef(0)
    const balanceRef = useRef()

    useEffect(() => {
        endBalanceRef.current = powerBalance
        setEndBalance(powerBalance)
    }, [powerBalance])
    const charsLength = useMemo(() => {
        function formatNumber(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return formatNumber(endBalance).length
    }, [endBalance])

    const countUpEnd = () => {
        setStartBalance(endBalanceRef.current)
    }

    const openPayClick = () => {
        eventBus.emit('recharge')
    }

    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100) ?
            globalUser?.membership?.level : 0
    }, [globalUser])

    // 虹豆弹框
    const balancePercent = useMemo(() => {
        return Math.ceil(powerBalance / globalUser?.membership?.amount * 100)
    }, [globalUser])

    // 剩余席位
    const remainingMembers = useMemo(() => {
        return globalOrgInfo?.current?.supportMembers - globalOrgInfo?.current?.currentMembers < 0 ? 0 :
            globalOrgInfo?.current?.supportMembers - globalOrgInfo?.current?.currentMembers
    }, [globalOrgInfo])

    const beanContent = (
        <div className={styles.beanContent}>
            <p><span>{Math.ceil(powerBalance)}</span>虹豆</p>
            <div className={styles.balance_p}>
                <span>剩余虹豆</span>
                <p>
                    <span>{powerBalance}</span>
                    <span>/</span>
                    <span>{globalUser?.membership?.amount}</span>
                </p>
            </div>
            <Progress
                className={styles.balance_progress}
                showInfo={false}
                percent={balancePercent}
                strokeColor="#006EFF"
            />
            {
                !(globalOrgInfo?.current?.role == 'member' && !globalOrgInfo.isPersonal) && <>
                    {
                        memberLevel == 0 ? <Button className={styles.upgradeBtn} type="primary" onClick={() => { eventBus.emit('recharge') }}>开通会员</Button> :
                            (memberLevel == 1 || memberLevel == 2 || memberLevel == 3 || memberLevel == 4) ? <Button className={styles.upgradeBtn} type="primary" onClick={() => { eventBus.emit('recharge') }}>升级套餐</Button> :
                                (memberLevel == 5 || memberLevel == 6 || memberLevel == 7 || memberLevel == 8) ? <Button className={styles.upgradeBtn} type="primary" onClick={() => { eventBus.emit('OPEN_DATA_SEAT') }}>增加席位</Button> :
                                    memberLevel == 9 ? null : <Button className={styles.upgradeBtn} type="primary" onClick={() => { eventBus.emit('recharge') }}>续购套餐</Button>
                    }
                    {
                        memberLevel !== 0 && <Button
                            className={styles.upgradeBtn2}
                            onClick={() => {
                                setOpen(false)
                                eventBus.emit('OPEN_DATA_PACKAGE')
                            }}
                        >虹豆加油包</Button>
                    }

                    <p className={styles.beanContentBottom}>
                        <span onClick={() => {
                            setOpen(false)
                            window.open("/home/personalCenter/personalTransaction", "_blank");
                        }}>虹豆明细</span>
                        <span onClick={() => {
                            setOpen(false)
                            openCouponClick()
                        }}>优惠券</span>
                    </p>
                </>
            }

        </div>
    )

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
        if (newOpen) {
            eventBus.emit('updateUserInfo')
            eventBus.emit('getUserOrgInfo')
            eventBus.emit('updatePower')
            eventBus.emit('updateActivityInfo')
        }
    }

    return (
        <div className={styles.LoggedHead}>
            <PromoteButtons.ServiceBtn />
            <PromoteButtons.InviteBtn />
            <PromoteButtons.MembershipBtn onClick={globalOrgInfo?.current?.role == 'member' ? null : openPayClick} />
            <Popover
                placement="bottom"
                content={beanContent}
                trigger="hover"
                open={open}
                onOpenChange={handleOpenChange}
            >
                <div className={styles.LoggedHead_power}>
                    <span className={styles.LoggedHead_powerAmount} ref={balanceRef} style={{ width: `calc(${charsLength} * 1ch)` }}>
                        {<CountUp start={startBalance} end={endBalance} separator="," onEnd={countUpEnd} />}
                    </span>
                </div>
            </Popover>

            <LoggedAvatar
                goCoupon={openCouponClick}
                goBack={goBack}
                openPayClick={openPayClick}
            />
            <CouponModal ref={couponChildRef} />
        </div>
    )
}

export default LoggedHead